// Publishing composer — the baked emoji dataset (item 4, 2026-07-28).
//
// STILL NO RUNTIME DEPENDENCY. A full emoji-picker package ships its own data
// file + styling + often its own popover; all the composer needs is "drop the
// right glyph into a caption", searchable, at zero runtime cost. So this is a
// much larger HAND-BAKED list than the original ~90-entry curated set: the eight
// standard Unicode categories, each entry keyworded for substring search. Same
// posture as the hand-rolled Sidebar / date-lib-free DateRangePicker.
//
// To extend: add an entry to a category. Keywords are matched as substrings, so a
// few well-chosen words per emoji is enough. Business-relevant terms (gym,
// fitness, car, dealership, sale, offer…) are deliberately seeded into the
// keywords so a social-caption search lands the obvious glyph first.

export interface EmojiEntry {
  char: string;
  keywords: string;
}

export interface EmojiCategory {
  id: string;
  name: string;
  /** A representative glyph shown on the category tab. */
  icon: string;
  emoji: EmojiEntry[];
}

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: 'smileys',
    name: 'Smileys & people',
    icon: '😀',
    emoji: [
      { char: '😀', keywords: 'grin smile happy face' },
      { char: '😃', keywords: 'smile happy joy face' },
      { char: '😄', keywords: 'smile laugh happy face' },
      { char: '😁', keywords: 'grin beam happy face' },
      { char: '😆', keywords: 'laugh haha lol grin' },
      { char: '😅', keywords: 'sweat relief nervous laugh' },
      { char: '🤣', keywords: 'rofl rolling laughing hard' },
      { char: '😂', keywords: 'joy tears laughing cry' },
      { char: '🙂', keywords: 'slight smile happy' },
      { char: '🙃', keywords: 'upside down silly' },
      { char: '😉', keywords: 'wink flirt' },
      { char: '😊', keywords: 'blush smile happy warm' },
      { char: '😇', keywords: 'angel halo innocent' },
      { char: '🥰', keywords: 'love hearts adore smiling' },
      { char: '😍', keywords: 'love heart eyes crush' },
      { char: '🤩', keywords: 'star struck excited wow amazed' },
      { char: '😘', keywords: 'kiss blow love' },
      { char: '😗', keywords: 'kiss whistle' },
      { char: '😚', keywords: 'kiss closed eyes' },
      { char: '😋', keywords: 'yum tasty tongue delicious' },
      { char: '😛', keywords: 'tongue playful cheeky' },
      { char: '😜', keywords: 'wink tongue silly' },
      { char: '🤪', keywords: 'zany goofy crazy wild' },
      { char: '😝', keywords: 'tongue squint playful' },
      { char: '🤑', keywords: 'money mouth rich dollar' },
      { char: '🤗', keywords: 'hug hands warm' },
      { char: '🤭', keywords: 'giggle oops hand mouth' },
      { char: '🤫', keywords: 'shush quiet secret' },
      { char: '🤔', keywords: 'think hmm consider' },
      { char: '🤐', keywords: 'zip mouth quiet' },
      { char: '🤨', keywords: 'raised eyebrow skeptical suspicious' },
      { char: '😐', keywords: 'neutral meh blank' },
      { char: '😑', keywords: 'expressionless blank' },
      { char: '😶', keywords: 'no mouth silent speechless' },
      { char: '😏', keywords: 'smirk smug' },
      { char: '😒', keywords: 'unamused annoyed meh' },
      { char: '🙄', keywords: 'eye roll whatever' },
      { char: '😬', keywords: 'grimace awkward yikes' },
      { char: '🤥', keywords: 'lie liar pinocchio' },
      { char: '😌', keywords: 'relieved calm content' },
      { char: '😔', keywords: 'sad pensive down' },
      { char: '😪', keywords: 'sleepy tired' },
      { char: '😴', keywords: 'sleep zzz tired' },
      { char: '😷', keywords: 'mask sick ill' },
      { char: '🤒', keywords: 'sick thermometer fever' },
      { char: '🤕', keywords: 'hurt injured bandage' },
      { char: '🤢', keywords: 'nauseated sick gross' },
      { char: '🤮', keywords: 'vomit sick throw up' },
      { char: '🤧', keywords: 'sneeze sick tissue' },
      { char: '🥵', keywords: 'hot heat sweating summer' },
      { char: '🥶', keywords: 'cold freezing winter' },
      { char: '😵', keywords: 'dizzy knocked out' },
      { char: '🤯', keywords: 'mind blown shocked wow' },
      { char: '🤠', keywords: 'cowboy hat yeehaw' },
      { char: '🥳', keywords: 'party celebrate hat birthday' },
      { char: '😎', keywords: 'cool sunglasses' },
      { char: '🤓', keywords: 'nerd glasses geek' },
      { char: '🧐', keywords: 'monocle inspect fancy' },
      { char: '😕', keywords: 'confused unsure' },
      { char: '😟', keywords: 'worried concerned' },
      { char: '🙁', keywords: 'frown slight sad' },
      { char: '😮', keywords: 'surprised wow open mouth' },
      { char: '😯', keywords: 'hushed surprised' },
      { char: '😲', keywords: 'astonished shocked gasp' },
      { char: '😳', keywords: 'flushed embarrassed shocked' },
      { char: '🥺', keywords: 'pleading puppy eyes please' },
      { char: '😦', keywords: 'frown open mouth' },
      { char: '😰', keywords: 'anxious sweat nervous' },
      { char: '😥', keywords: 'sad disappointed relieved' },
      { char: '😢', keywords: 'cry sad tear' },
      { char: '😭', keywords: 'sob crying loud sad' },
      { char: '😱', keywords: 'scream shocked fear' },
      { char: '😖', keywords: 'confounded frustrated' },
      { char: '😣', keywords: 'persevere struggle' },
      { char: '😞', keywords: 'disappointed sad' },
      { char: '😓', keywords: 'sweat downcast' },
      { char: '😩', keywords: 'weary tired frustrated' },
      { char: '😫', keywords: 'tired exhausted' },
      { char: '🥱', keywords: 'yawn bored tired' },
      { char: '😤', keywords: 'triumph steam determined' },
      { char: '😡', keywords: 'angry mad rage red' },
      { char: '😠', keywords: 'angry mad annoyed' },
      { char: '🤬', keywords: 'swearing cursing angry' },
      { char: '😈', keywords: 'devil mischief evil grin' },
      { char: '💀', keywords: 'skull dead' },
      { char: '💩', keywords: 'poop funny' },
      { char: '🤡', keywords: 'clown joke' },
      { char: '👻', keywords: 'ghost boo spooky' },
      { char: '👽', keywords: 'alien ufo' },
      { char: '🤖', keywords: 'robot bot ai' },
      { char: '👋', keywords: 'wave hello hi bye' },
      { char: '🤚', keywords: 'raised back hand stop' },
      { char: '✋', keywords: 'raised hand high five stop' },
      { char: '🖐️', keywords: 'hand fingers splayed' },
      { char: '👌', keywords: 'ok perfect good' },
      { char: '🤌', keywords: 'pinched fingers italian' },
      { char: '🤏', keywords: 'pinch small tiny' },
      { char: '✌️', keywords: 'peace victory two' },
      { char: '🤞', keywords: 'fingers crossed luck hope' },
      { char: '🤟', keywords: 'love you rock hand' },
      { char: '🤘', keywords: 'rock horns metal' },
      { char: '🤙', keywords: 'call me shaka hang loose' },
      { char: '👈', keywords: 'point left' },
      { char: '👉', keywords: 'point right' },
      { char: '👆', keywords: 'point up' },
      { char: '👇', keywords: 'point down link below' },
      { char: '☝️', keywords: 'point up index one' },
      { char: '👍', keywords: 'thumbs up yes good like approve' },
      { char: '👎', keywords: 'thumbs down no bad dislike' },
      { char: '✊', keywords: 'fist raised power' },
      { char: '👊', keywords: 'fist bump punch' },
      { char: '👏', keywords: 'clap applause bravo' },
      { char: '🙌', keywords: 'raise hands celebrate praise' },
      { char: '👐', keywords: 'open hands hug' },
      { char: '🤲', keywords: 'palms up together' },
      { char: '🤝', keywords: 'handshake deal partner agree' },
      { char: '🙏', keywords: 'pray thanks please hope' },
      { char: '✍️', keywords: 'writing hand sign' },
      { char: '💪', keywords: 'strong muscle gym fitness flex' },
      { char: '🫶', keywords: 'heart hands love' },
      { char: '👀', keywords: 'eyes look watch' },
      { char: '🧠', keywords: 'brain smart think' },
      { char: '👶', keywords: 'baby infant' },
      { char: '🧒', keywords: 'child kid' },
      { char: '👦', keywords: 'boy child' },
      { char: '👧', keywords: 'girl child' },
      { char: '🧑', keywords: 'person adult' },
      { char: '👨', keywords: 'man male' },
      { char: '👩', keywords: 'woman female' },
      { char: '🧔', keywords: 'beard person' },
      { char: '👴', keywords: 'old man grandpa' },
      { char: '👵', keywords: 'old woman grandma' },
      { char: '🧑‍💼', keywords: 'office worker professional staff' },
      { char: '🧑‍🏫', keywords: 'teacher instructor coach' },
      { char: '🧑‍🔧', keywords: 'mechanic technician service' },
      { char: '🏃', keywords: 'run running cardio' },
      { char: '🚶', keywords: 'walk walking' },
      { char: '🧍', keywords: 'stand person' },
      { char: '💃', keywords: 'dance dancing woman' },
      { char: '🕺', keywords: 'dance dancing man' },
    ],
  },
  {
    id: 'animals',
    name: 'Animals & nature',
    icon: '🐻',
    emoji: [
      { char: '🐶', keywords: 'dog puppy pet' },
      { char: '🐱', keywords: 'cat kitten pet' },
      { char: '🐭', keywords: 'mouse' },
      { char: '🐹', keywords: 'hamster pet' },
      { char: '🐰', keywords: 'rabbit bunny' },
      { char: '🦊', keywords: 'fox' },
      { char: '🐻', keywords: 'bear' },
      { char: '🐼', keywords: 'panda' },
      { char: '🐨', keywords: 'koala australia' },
      { char: '🐯', keywords: 'tiger' },
      { char: '🦁', keywords: 'lion' },
      { char: '🐮', keywords: 'cow' },
      { char: '🐷', keywords: 'pig' },
      { char: '🐸', keywords: 'frog' },
      { char: '🐵', keywords: 'monkey' },
      { char: '🐔', keywords: 'chicken hen' },
      { char: '🐧', keywords: 'penguin' },
      { char: '🐦', keywords: 'bird' },
      { char: '🦅', keywords: 'eagle bird' },
      { char: '🦆', keywords: 'duck' },
      { char: '🦉', keywords: 'owl' },
      { char: '🦄', keywords: 'unicorn magic' },
      { char: '🐝', keywords: 'bee honey' },
      { char: '🦋', keywords: 'butterfly' },
      { char: '🐢', keywords: 'turtle' },
      { char: '🐍', keywords: 'snake' },
      { char: '🐙', keywords: 'octopus' },
      { char: '🐠', keywords: 'fish tropical' },
      { char: '🐬', keywords: 'dolphin' },
      { char: '🐳', keywords: 'whale' },
      { char: '🦈', keywords: 'shark' },
      { char: '🐊', keywords: 'crocodile croc australia' },
      { char: '🦘', keywords: 'kangaroo australia' },
      { char: '🐴', keywords: 'horse' },
      { char: '🐑', keywords: 'sheep' },
      { char: '🐕', keywords: 'dog' },
      { char: '🌵', keywords: 'cactus desert plant' },
      { char: '🌲', keywords: 'tree evergreen' },
      { char: '🌳', keywords: 'tree' },
      { char: '🌴', keywords: 'palm tree tropical' },
      { char: '🌱', keywords: 'seedling grow plant new' },
      { char: '🌿', keywords: 'herb leaf plant' },
      { char: '🍀', keywords: 'clover luck four leaf' },
      { char: '🍃', keywords: 'leaves wind' },
      { char: '🌷', keywords: 'tulip flower' },
      { char: '🌹', keywords: 'rose flower love' },
      { char: '🌸', keywords: 'blossom cherry flower spring' },
      { char: '🌺', keywords: 'hibiscus flower' },
      { char: '🌻', keywords: 'sunflower flower' },
      { char: '🌼', keywords: 'daisy flower' },
      { char: '💐', keywords: 'bouquet flowers' },
      { char: '🌞', keywords: 'sun sunny summer' },
      { char: '🌝', keywords: 'moon full face' },
      { char: '⭐', keywords: 'star rating review' },
      { char: '🌟', keywords: 'star glow sparkle shine' },
      { char: '✨', keywords: 'sparkles new shine magic' },
      { char: '⚡', keywords: 'lightning fast energy bolt' },
      { char: '🔥', keywords: 'fire hot trending lit' },
      { char: '🌈', keywords: 'rainbow pride' },
      { char: '☀️', keywords: 'sun sunny clear summer' },
      { char: '⛅', keywords: 'partly cloudy sun' },
      { char: '☁️', keywords: 'cloud cloudy' },
      { char: '🌧️', keywords: 'rain rainy weather' },
      { char: '⛈️', keywords: 'storm thunder' },
      { char: '❄️', keywords: 'snow snowflake cold winter' },
      { char: '⛄', keywords: 'snowman winter' },
      { char: '💧', keywords: 'water drop hydrate' },
      { char: '🌊', keywords: 'wave ocean sea surf' },
    ],
  },
  {
    id: 'food',
    name: 'Food & drink',
    icon: '🍔',
    emoji: [
      { char: '🍏', keywords: 'apple green healthy' },
      { char: '🍎', keywords: 'apple red healthy' },
      { char: '🍊', keywords: 'orange citrus' },
      { char: '🍋', keywords: 'lemon citrus' },
      { char: '🍌', keywords: 'banana' },
      { char: '🍉', keywords: 'watermelon summer' },
      { char: '🍇', keywords: 'grapes wine' },
      { char: '🍓', keywords: 'strawberry berry' },
      { char: '🫐', keywords: 'blueberries berry' },
      { char: '🍒', keywords: 'cherries' },
      { char: '🍑', keywords: 'peach' },
      { char: '🥭', keywords: 'mango tropical' },
      { char: '🍍', keywords: 'pineapple' },
      { char: '🥥', keywords: 'coconut' },
      { char: '🥝', keywords: 'kiwi fruit' },
      { char: '🍅', keywords: 'tomato' },
      { char: '🥑', keywords: 'avocado healthy' },
      { char: '🥦', keywords: 'broccoli vegetable healthy' },
      { char: '🥕', keywords: 'carrot vegetable' },
      { char: '🌽', keywords: 'corn' },
      { char: '🥗', keywords: 'salad healthy nutrition' },
      { char: '🍞', keywords: 'bread' },
      { char: '🥐', keywords: 'croissant pastry' },
      { char: '🥯', keywords: 'bagel' },
      { char: '🧀', keywords: 'cheese' },
      { char: '🥚', keywords: 'egg' },
      { char: '🍳', keywords: 'egg fried breakfast cooking' },
      { char: '🥓', keywords: 'bacon' },
      { char: '🍔', keywords: 'burger hamburger' },
      { char: '🍟', keywords: 'fries chips' },
      { char: '🍕', keywords: 'pizza' },
      { char: '🌭', keywords: 'hot dog' },
      { char: '🥪', keywords: 'sandwich' },
      { char: '🌮', keywords: 'taco mexican' },
      { char: '🌯', keywords: 'burrito wrap' },
      { char: '🍜', keywords: 'noodles ramen' },
      { char: '🍝', keywords: 'pasta spaghetti' },
      { char: '🍣', keywords: 'sushi' },
      { char: '🍚', keywords: 'rice' },
      { char: '🍗', keywords: 'chicken drumstick meat' },
      { char: '🥩', keywords: 'steak meat' },
      { char: '🍦', keywords: 'ice cream soft serve' },
      { char: '🍩', keywords: 'donut doughnut' },
      { char: '🍪', keywords: 'cookie biscuit' },
      { char: '🎂', keywords: 'cake birthday celebrate' },
      { char: '🧁', keywords: 'cupcake' },
      { char: '🍫', keywords: 'chocolate' },
      { char: '🍬', keywords: 'candy sweet' },
      { char: '🍭', keywords: 'lollipop sweet' },
      { char: '🍿', keywords: 'popcorn movie' },
      { char: '☕', keywords: 'coffee tea hot drink' },
      { char: '🍵', keywords: 'tea green' },
      { char: '🥤', keywords: 'drink cup shake protein soda' },
      { char: '🧋', keywords: 'bubble tea boba' },
      { char: '🧃', keywords: 'juice box' },
      { char: '🍺', keywords: 'beer drink' },
      { char: '🍻', keywords: 'beers cheers drink' },
      { char: '🍷', keywords: 'wine drink' },
      { char: '🥂', keywords: 'champagne cheers celebrate toast' },
      { char: '🍾', keywords: 'champagne bottle celebrate' },
      { char: '🍸', keywords: 'cocktail drink' },
    ],
  },
  {
    id: 'activity',
    name: 'Activity',
    icon: '⚽',
    emoji: [
      { char: '⚽', keywords: 'soccer football ball' },
      { char: '🏀', keywords: 'basketball ball' },
      { char: '🏈', keywords: 'american football' },
      { char: '⚾', keywords: 'baseball' },
      { char: '🥎', keywords: 'softball' },
      { char: '🎾', keywords: 'tennis' },
      { char: '🏐', keywords: 'volleyball' },
      { char: '🏉', keywords: 'rugby' },
      { char: '🎱', keywords: 'pool billiards 8 ball' },
      { char: '🏓', keywords: 'ping pong table tennis' },
      { char: '🏸', keywords: 'badminton' },
      { char: '🥅', keywords: 'goal net' },
      { char: '🏒', keywords: 'hockey' },
      { char: '🏑', keywords: 'field hockey' },
      { char: '🥍', keywords: 'lacrosse' },
      { char: '🏏', keywords: 'cricket bat' },
      { char: '⛳', keywords: 'golf flag hole' },
      { char: '🏹', keywords: 'archery bow arrow target' },
      { char: '🎣', keywords: 'fishing' },
      { char: '🥊', keywords: 'boxing glove fight' },
      { char: '🥋', keywords: 'martial arts karate' },
      { char: '⛸️', keywords: 'ice skating' },
      { char: '🛹', keywords: 'skateboard' },
      { char: '🛼', keywords: 'roller skate' },
      { char: '🎿', keywords: 'ski snow' },
      { char: '🏂', keywords: 'snowboard' },
      { char: '🏋️', keywords: 'weightlifting gym lift strong fitness' },
      { char: '🤸', keywords: 'cartwheel gymnastics move class' },
      { char: '🤼', keywords: 'wrestling' },
      { char: '🤽', keywords: 'water polo' },
      { char: '🏊', keywords: 'swim pool swimming' },
      { char: '🚴', keywords: 'cycling bike spin' },
      { char: '🚵', keywords: 'mountain biking' },
      { char: '🧗', keywords: 'climbing' },
      { char: '🧘', keywords: 'yoga meditate calm stretch' },
      { char: '🤾', keywords: 'handball' },
      { char: '🏆', keywords: 'trophy win champion challenge' },
      { char: '🥇', keywords: 'gold medal first winner' },
      { char: '🥈', keywords: 'silver medal second' },
      { char: '🥉', keywords: 'bronze medal third' },
      { char: '🏅', keywords: 'medal award' },
      { char: '🎖️', keywords: 'military medal honour' },
      { char: '🎯', keywords: 'target bullseye goal dart' },
      { char: '🎮', keywords: 'gaming video game controller' },
      { char: '🎲', keywords: 'dice game' },
      { char: '🎳', keywords: 'bowling' },
      { char: '🎭', keywords: 'theatre arts drama' },
      { char: '🎨', keywords: 'art paint palette creative' },
      { char: '🎬', keywords: 'movie film clapper' },
      { char: '🎤', keywords: 'microphone sing karaoke' },
      { char: '🎧', keywords: 'headphones music' },
      { char: '🎸', keywords: 'guitar music' },
      { char: '🎹', keywords: 'piano keyboard music' },
      { char: '🥁', keywords: 'drums music' },
      { char: '🎺', keywords: 'trumpet music' },
      { char: '🎻', keywords: 'violin music' },
      { char: '🎉', keywords: 'party celebrate launch tada' },
      { char: '🎊', keywords: 'confetti celebrate party' },
      { char: '🎈', keywords: 'balloon party' },
      { char: '🎇', keywords: 'fireworks sparkler' },
      { char: '🎆', keywords: 'fireworks celebrate' },
      { char: '🎪', keywords: 'circus tent event' },
      { char: '🎟️', keywords: 'ticket admission event' },
    ],
  },
  {
    id: 'travel',
    name: 'Travel & places',
    icon: '✈️',
    emoji: [
      { char: '🚗', keywords: 'car auto vehicle dealership' },
      { char: '🚕', keywords: 'taxi cab' },
      { char: '🚙', keywords: 'suv car vehicle' },
      { char: '🚌', keywords: 'bus' },
      { char: '🚎', keywords: 'trolleybus' },
      { char: '🏎️', keywords: 'race car fast racing' },
      { char: '🚓', keywords: 'police car' },
      { char: '🚑', keywords: 'ambulance emergency' },
      { char: '🚒', keywords: 'fire truck' },
      { char: '🚐', keywords: 'van rv camper minibus' },
      { char: '🛻', keywords: 'ute truck pickup' },
      { char: '🚚', keywords: 'truck delivery' },
      { char: '🚛', keywords: 'semi truck lorry' },
      { char: '🚜', keywords: 'tractor farm' },
      { char: '🏍️', keywords: 'motorcycle bike' },
      { char: '🛵', keywords: 'scooter moped' },
      { char: '🚲', keywords: 'bicycle bike' },
      { char: '🛴', keywords: 'scooter kick' },
      { char: '🚀', keywords: 'rocket launch grow fast' },
      { char: '✈️', keywords: 'plane flight travel fly' },
      { char: '🛫', keywords: 'takeoff departure plane' },
      { char: '🛬', keywords: 'landing arrival plane' },
      { char: '🚁', keywords: 'helicopter' },
      { char: '⛵', keywords: 'sailboat yacht' },
      { char: '🚤', keywords: 'speedboat' },
      { char: '🛥️', keywords: 'motor boat' },
      { char: '🚢', keywords: 'ship cruise' },
      { char: '⚓', keywords: 'anchor boat' },
      { char: '🚦', keywords: 'traffic light signal' },
      { char: '🚧', keywords: 'construction roadwork' },
      { char: '⛽', keywords: 'fuel petrol gas station' },
      { char: '🗺️', keywords: 'map travel' },
      { char: '📍', keywords: 'location pin here address' },
      { char: '🧭', keywords: 'compass direction' },
      { char: '🏔️', keywords: 'mountain snow peak' },
      { char: '⛰️', keywords: 'mountain' },
      { char: '🌋', keywords: 'volcano' },
      { char: '🏕️', keywords: 'camping tent' },
      { char: '🏖️', keywords: 'beach summer holiday' },
      { char: '🏝️', keywords: 'island tropical' },
      { char: '🏜️', keywords: 'desert' },
      { char: '🏠', keywords: 'house home' },
      { char: '🏡', keywords: 'house home garden' },
      { char: '🏢', keywords: 'office building work' },
      { char: '🏬', keywords: 'department store shop' },
      { char: '🏪', keywords: 'store shop convenience dealership' },
      { char: '🏫', keywords: 'school' },
      { char: '🏥', keywords: 'hospital' },
      { char: '🏦', keywords: 'bank' },
      { char: '🏨', keywords: 'hotel' },
      { char: '🏟️', keywords: 'stadium arena' },
      { char: '🏛️', keywords: 'building classical bank' },
      { char: '⛪', keywords: 'church' },
      { char: '🌆', keywords: 'city dusk skyline' },
      { char: '🌃', keywords: 'city night' },
      { char: '🌉', keywords: 'bridge night' },
      { char: '🎡', keywords: 'ferris wheel fair' },
      { char: '🎢', keywords: 'roller coaster theme park' },
      { char: '🗽', keywords: 'statue liberty new york' },
      { char: '🗼', keywords: 'tower tokyo' },
      { char: '🌏', keywords: 'earth world global australia asia' },
      { char: '🌍', keywords: 'earth world global africa europe' },
    ],
  },
  {
    id: 'objects',
    name: 'Objects',
    icon: '💡',
    emoji: [
      { char: '⌚', keywords: 'watch time' },
      { char: '📱', keywords: 'phone mobile smartphone' },
      { char: '💻', keywords: 'laptop computer' },
      { char: '🖥️', keywords: 'desktop computer monitor' },
      { char: '⌨️', keywords: 'keyboard' },
      { char: '🖱️', keywords: 'mouse computer' },
      { char: '🖨️', keywords: 'printer' },
      { char: '📷', keywords: 'camera photo' },
      { char: '📸', keywords: 'camera flash photo' },
      { char: '📹', keywords: 'video camera' },
      { char: '🎥', keywords: 'movie camera film' },
      { char: '📺', keywords: 'tv television' },
      { char: '📻', keywords: 'radio' },
      { char: '☎️', keywords: 'phone call telephone' },
      { char: '📞', keywords: 'phone call receiver' },
      { char: '📟', keywords: 'pager' },
      { char: '🔋', keywords: 'battery power' },
      { char: '🔌', keywords: 'plug power electric' },
      { char: '💡', keywords: 'idea light bulb bright' },
      { char: '🔦', keywords: 'flashlight torch' },
      { char: '🕯️', keywords: 'candle' },
      { char: '💰', keywords: 'money bag price save deal' },
      { char: '💵', keywords: 'money cash dollar' },
      { char: '💳', keywords: 'card credit pay' },
      { char: '🧾', keywords: 'receipt invoice bill' },
      { char: '💎', keywords: 'diamond gem premium' },
      { char: '⚖️', keywords: 'scales balance justice' },
      { char: '🧰', keywords: 'toolbox tools' },
      { char: '🔧', keywords: 'wrench spanner service repair' },
      { char: '🔨', keywords: 'hammer build' },
      { char: '🛠️', keywords: 'tools service repair hammer wrench' },
      { char: '⚙️', keywords: 'gear settings cog' },
      { char: '🔩', keywords: 'nut bolt' },
      { char: '🧲', keywords: 'magnet attract' },
      { char: '🔑', keywords: 'key keys new car unlock' },
      { char: '🔒', keywords: 'lock secure closed' },
      { char: '🔓', keywords: 'unlock open' },
      { char: '🔔', keywords: 'bell notification alert' },
      { char: '📣', keywords: 'megaphone announce shout' },
      { char: '📢', keywords: 'loudspeaker announce loud' },
      { char: '📆', keywords: 'calendar date booking' },
      { char: '📅', keywords: 'calendar date schedule' },
      { char: '📌', keywords: 'pin pushpin' },
      { char: '📎', keywords: 'paperclip attach' },
      { char: '✂️', keywords: 'scissors cut' },
      { char: '📝', keywords: 'memo note write' },
      { char: '✏️', keywords: 'pencil write edit' },
      { char: '🖊️', keywords: 'pen write' },
      { char: '📖', keywords: 'book open read' },
      { char: '📚', keywords: 'books library' },
      { char: '📈', keywords: 'chart up growth increase trending' },
      { char: '📉', keywords: 'chart down decrease' },
      { char: '📊', keywords: 'bar chart stats data' },
      { char: '📦', keywords: 'package box delivery shipping' },
      { char: '🎁', keywords: 'gift present free bonus' },
      { char: '🏷️', keywords: 'tag price label offer sale' },
      { char: '🛒', keywords: 'shopping cart trolley buy' },
      { char: '🛍️', keywords: 'shopping bags retail' },
      { char: '⏰', keywords: 'alarm clock deadline hurry time' },
      { char: '⏳', keywords: 'hourglass time waiting' },
      { char: '⌛', keywords: 'hourglass done time' },
      { char: '🔍', keywords: 'search magnify find' },
      { char: '🔎', keywords: 'search magnify zoom' },
      { char: '💊', keywords: 'pill medicine health' },
      { char: '🩺', keywords: 'stethoscope health doctor' },
      { char: '🚿', keywords: 'shower' },
      { char: '🛁', keywords: 'bath' },
    ],
  },
  {
    id: 'symbols',
    name: 'Symbols',
    icon: '❤️',
    emoji: [
      { char: '❤️', keywords: 'heart love red health' },
      { char: '🧡', keywords: 'orange heart love' },
      { char: '💛', keywords: 'yellow heart love' },
      { char: '💚', keywords: 'green heart love' },
      { char: '💙', keywords: 'blue heart love' },
      { char: '💜', keywords: 'purple heart love' },
      { char: '🖤', keywords: 'black heart' },
      { char: '🤍', keywords: 'white heart' },
      { char: '🤎', keywords: 'brown heart' },
      { char: '💔', keywords: 'broken heart' },
      { char: '❣️', keywords: 'heart exclamation love' },
      { char: '💕', keywords: 'two hearts love' },
      { char: '💞', keywords: 'revolving hearts love' },
      { char: '💓', keywords: 'beating heart love' },
      { char: '💗', keywords: 'growing heart love' },
      { char: '💖', keywords: 'sparkling heart love' },
      { char: '💘', keywords: 'heart arrow cupid love' },
      { char: '💝', keywords: 'heart gift ribbon' },
      { char: '💯', keywords: 'hundred perfect keep it' },
      { char: '💢', keywords: 'anger comic mad' },
      { char: '💥', keywords: 'boom collision big' },
      { char: '💫', keywords: 'dizzy stars' },
      { char: '💦', keywords: 'sweat splash water' },
      { char: '💨', keywords: 'dash wind fast' },
      { char: '🕳️', keywords: 'hole' },
      { char: '💬', keywords: 'speech bubble comment chat' },
      { char: '💭', keywords: 'thought bubble think' },
      { char: '🗯️', keywords: 'anger speech bubble' },
      { char: '✅', keywords: 'check tick done yes correct' },
      { char: '☑️', keywords: 'checkbox ticked done' },
      { char: '✔️', keywords: 'check tick done' },
      { char: '❌', keywords: 'cross no wrong x' },
      { char: '❎', keywords: 'cross mark button no' },
      { char: '➕', keywords: 'plus add' },
      { char: '➖', keywords: 'minus subtract' },
      { char: '➗', keywords: 'divide' },
      { char: '✖️', keywords: 'multiply times x' },
      { char: '♾️', keywords: 'infinity forever' },
      { char: '‼️', keywords: 'double exclamation' },
      { char: '⁉️', keywords: 'exclamation question' },
      { char: '❓', keywords: 'question mark' },
      { char: '❗', keywords: 'exclamation mark important' },
      { char: '⚠️', keywords: 'warning caution alert' },
      { char: '🚫', keywords: 'no prohibited forbidden' },
      { char: '✳️', keywords: 'asterisk' },
      { char: '❇️', keywords: 'sparkle new' },
      { char: '🆕', keywords: 'new' },
      { char: '🆓', keywords: 'free' },
      { char: '🆒', keywords: 'cool' },
      { char: '🆗', keywords: 'ok' },
      { char: '🆙', keywords: 'up new' },
      { char: '🔝', keywords: 'top up' },
      { char: '🔥', keywords: 'fire hot' },
      { char: '⭐', keywords: 'star favourite' },
      { char: '🌟', keywords: 'glowing star' },
      { char: '💲', keywords: 'dollar money price' },
      { char: '➡️', keywords: 'arrow right next' },
      { char: '⬅️', keywords: 'arrow left back' },
      { char: '⬆️', keywords: 'arrow up' },
      { char: '⬇️', keywords: 'arrow down' },
      { char: '↗️', keywords: 'arrow up right' },
      { char: '🔗', keywords: 'link url bio chain' },
      { char: '♻️', keywords: 'recycle green eco' },
      { char: '🔞', keywords: 'no under 18 adult' },
      { char: '🎵', keywords: 'music note' },
      { char: '🎶', keywords: 'music notes' },
    ],
  },
  {
    id: 'flags',
    name: 'Flags',
    icon: '🚩',
    emoji: [
      { char: '🏁', keywords: 'checkered flag finish race' },
      { char: '🚩', keywords: 'red flag marker' },
      { char: '🏴', keywords: 'black flag' },
      { char: '🏳️', keywords: 'white flag' },
      { char: '🏳️‍🌈', keywords: 'rainbow pride flag' },
      { char: '🇦🇺', keywords: 'australia aussie au flag' },
      { char: '🇳🇿', keywords: 'new zealand nz kiwi flag' },
      { char: '🇬🇧', keywords: 'united kingdom uk britain flag' },
      { char: '🇺🇸', keywords: 'united states usa america flag' },
      { char: '🇨🇦', keywords: 'canada flag' },
      { char: '🇮🇪', keywords: 'ireland flag' },
      { char: '🇫🇷', keywords: 'france french flag' },
      { char: '🇩🇪', keywords: 'germany german flag' },
      { char: '🇮🇹', keywords: 'italy italian flag' },
      { char: '🇪🇸', keywords: 'spain spanish flag' },
      { char: '🇵🇹', keywords: 'portugal flag' },
      { char: '🇳🇱', keywords: 'netherlands dutch flag' },
      { char: '🇯🇵', keywords: 'japan japanese flag' },
      { char: '🇨🇳', keywords: 'china chinese flag' },
      { char: '🇰🇷', keywords: 'korea south korean flag' },
      { char: '🇮🇳', keywords: 'india indian flag' },
      { char: '🇧🇷', keywords: 'brazil brazilian flag' },
      { char: '🇲🇽', keywords: 'mexico mexican flag' },
      { char: '🇿🇦', keywords: 'south africa flag' },
      { char: '🇸🇬', keywords: 'singapore flag' },
      { char: '🇦🇪', keywords: 'uae emirates dubai flag' },
      { char: '🇫🇯', keywords: 'fiji flag' },
    ],
  },
];

// Flat view for cross-category search.
export const ALL_EMOJI: EmojiEntry[] = EMOJI_CATEGORIES.flatMap((c) => c.emoji);

export interface EmojiSearchResult {
  emoji: EmojiEntry[];
  /** The cap trimmed the results — surfaced so the UI can hint "keep typing". */
  truncated: boolean;
}

function matches(entry: EmojiEntry, query: string): boolean {
  return entry.keywords.includes(query) || entry.char === query;
}

/**
 * Search across EVERY category (keyword substring / exact glyph), deduped by
 * glyph and capped for render perf. Pure + tested.
 */
export function searchEmoji(query: string, limit: number): EmojiSearchResult {
  const q = query.trim().toLowerCase();
  if (q === '') return { emoji: [], truncated: false };
  const seen = new Set<string>();
  const hits: EmojiEntry[] = [];
  for (const entry of ALL_EMOJI) {
    if (!matches(entry, q) || seen.has(entry.char)) continue;
    seen.add(entry.char);
    hits.push(entry);
  }
  return { emoji: hits.slice(0, limit), truncated: hits.length > limit };
}
